<div class="brnads-main">
  <div class="heading">
    <h3>Discover our Brands <span class="simple-font-family">({{topBrandsListing?.length ? topBrandsListing?.length :
        0}})</span></h3>
    <button class="view-all-button" (click)="openBrandModal()">View All</button>
  </div>

  <ngx-slick-carousel class=" " #slickModal="slick-carousel" [config]="slideConfigbrands">
    <div ngxSlickItem *ngFor="let brand of topBrandsListing;let i=index" class="slide">
      <div class="brands-images-main" (click)="onBrandSelection(brand.id)">
        <div class="brands-imags-box cursor" *ngIf="brand.brand_image">
          <img  [src]="statePersist.getSafeUrl(brand.brand_image)" alt="">
        </div>
        <div class="brands-text-box" *ngIf="!brand.brand_image">
          <p>{{brand?.label}}</p>
        </div>

      </div>
    </div>
  </ngx-slick-carousel>
</div>